module.exports = __webpack_public_path__ + "img/gh-305em-03-24.prt.978dbcca.jpg";